// utils/env.js - Utilitaire de détection d'environnement
/**
 * Détecte si l'application est en mode développement
 * @returns {boolean} true si en développement, false si en production
 */
export const isDevelopment = () => {
  if (typeof window === 'undefined') return false;
  
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('localhost') ||
    import.meta.env.DEV ||
    import.meta.env.MODE === 'development'
  );
};

/**
 * Détecte si l'application est en mode production
 * @returns {boolean} true si en production, false si en développement
 */
export const isProduction = () => {
  if (typeof window === 'undefined') return true; // Par défaut, côté serveur = production
  
  return (
    window.location.hostname === 'app-secura.com' ||
    window.location.hostname === 'www.app-secura.com' ||
    window.location.hostname.includes('app-secura.com')
  );
};

/**
 * Obtient l'URL de l'API selon l'environnement
 * @returns {string} URL de l'API
 */
/** test.app-secura.com : serveur de test (base secura-test-2026), jamais l'API de production. */
export const isStaging = () =>
  typeof window !== 'undefined' && window.location.hostname.startsWith('test.');

export const getApiUrl = () => {
  if (isStaging()) {
    return `https://${window.location.hostname}`;
  }
  if (isProduction()) {
    return 'https://app-secura.com';
  }

  // En dev sur localhost : cibler le serveur local (évite d'appeler la prod si .env pointe app-secura.com)
  if (isDevelopment()) {
    const envUrl = (import.meta.env.VITE_API_URL || '').trim();
    if (envUrl && !envUrl.includes('app-secura.com')) {
      return envUrl;
    }
    return 'http://localhost:3001';
  }

  return import.meta.env.VITE_API_URL || 'http://localhost:3001';
};

/**
 * Obtient l'URL du frontend selon l'environnement
 * @returns {string} URL du frontend
 */
export const getFrontendUrl = () => {
  if (isStaging()) {
    return `https://${window.location.hostname}`;
  }
  if (isProduction()) {
    return 'https://app-secura.com';
  }
  
  // En développement, utiliser localhost:5173 (port Vite par défaut)
  return import.meta.env.VITE_CLIENT_URL || 'http://localhost:5173';
};

/**
 * Obtient l'URL WebSocket selon l'environnement
 * @returns {string} URL WebSocket
 */
export const getWebSocketUrl = () => {
  return getApiUrl(); // WebSocket utilise la même URL que l'API
};
